webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(154),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(83);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vueComs = {};

var vueContext = __webpack_require__(170);
vueContext.keys().forEach(function (path) {
  var com = vueContext(path);
  vueComs[com.name] = com;
  exports[com.name] = com;
});

var loaderContext = __webpack_require__(171);
loaderContext.keys().forEach(function (path) {
  var com = loaderContext(path).default;
  // fix: uglify would kill the function name
  var name = path.match(/([^/]+)\.js$/)[1];
  exports[name] = com;
});

exports.install = function (Vue) {
  (0, _keys2.default)(vueComs).forEach(function (k) {
    // fix: name 'object3d' is required,
    // or it would be parsed to 'object-3-d' somewhere else
    var rk = k;
    if (k === 'Object3D') rk = 'object3d';
    Vue.component(rk, vueComs[k]);
  });
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$vec = undefined;

var _three = __webpack_require__(1);

// for simplicity
// using plain object `{ x, y, z }` to describe vector
// instead of class Vector3
var $vec = {
  multiplyScalar: function multiplyScalar(v, s) {
    v = this.toVector3(v);
    v.multiplyScalar(s);
    return this.toPlainObj(v);
  },
  add: function add(v1, v2) {
    v1 = this.toVector3(v1);
    v2 = this.toVector3(v2);
    var v = v1.add(v2);
    return this.toPlainObj(v);
  },
  toVector3: function toVector3(v) {
    v = v || {};
    return new _three.Vector3(v.x, v.y, v.z);
  },
  toPlainObj: function toPlainObj(v) {
    var x = v.x,
        y = v.y,
        z = v.z;

    return { x: x, y: y, z: z };
  }
};

exports.$vec = $vec;

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(157),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(161),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModel = getModel;
exports.setupPanel = setupPanel;
function getModel() {
  var ui = {
    camera: {
      x: 9, y: 21, z: 20
    },
    ocean: {
      y: -200
    },
    sf03: {
      scale: 1
    },
    movemSysKey: 0,
    replay: function replay() {
      ui.movemSysKey += 1;
    }
  };
  return ui;
}

function setupPanel(gui, ui) {
  var fc = gui.addFolder('Camera');
  fc.add(ui.camera, 'x', -50, 50).step(0.01);
  fc.add(ui.camera, 'y', -50, 50).step(0.01);
  fc.add(ui.camera, 'z', -50, 50).step(0.01);
  fc.open();

  var fo = gui.addFolder('Ocean');
  fo.add(ui.ocean, 'y', -250, 10).step(0.01);
  fo.open();

  var fs = gui.addFolder('SF03');
  fs.add(ui.sf03, 'scale', 0.1, 7).step(0.01);
  fs.open();
  gui.add(ui, 'replay');
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(28);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(47);

var _App2 = _interopRequireDefault(_App);

var _ = __webpack_require__(13);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_2.default); // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperties = __webpack_require__(82);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _create = __webpack_require__(81);

var _create2 = _interopRequireDefault(_create);

exports.default = OrbitControls;

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author qiao / https://github.com/qiao
 * @author mrdoob / http://mrdoob.com
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author erich666 / http://erichaines.com
 */

// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one finger move
//    Zoom - middle mouse, or mousewheel / touch: two finger spread or squish
//    Pan - right mouse, or arrow keys / touch: three finter swipe

function OrbitControls(object, domElement) {

  this.object = object;

  this.domElement = domElement !== undefined ? domElement : document;

  // Set to false to disable this control
  this.enabled = true;

  // "target" sets the location of focus, where the object orbits around
  this.target = new THREE.Vector3();

  // How far you can dolly in and out ( PerspectiveCamera only )
  this.minDistance = 0;
  this.maxDistance = Infinity;

  // How far you can zoom in and out ( OrthographicCamera only )
  this.minZoom = 0;
  this.maxZoom = Infinity;

  // How far you can orbit vertically, upper and lower limits.
  // Range is 0 to Math.PI radians.
  this.minPolarAngle = 0; // radians
  this.maxPolarAngle = Math.PI; // radians

  // How far you can orbit horizontally, upper and lower limits.
  // If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
  this.minAzimuthAngle = -Infinity; // radians
  this.maxAzimuthAngle = Infinity; // radians

  // Set to true to enable damping (inertia)
  // If damping is enabled, you must call controls.update() in your animation loop
  this.enableDamping = false;
  this.dampingFactor = 0.25;

  // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
  // Set to false to disable zooming
  this.enableZoom = true;
  this.zoomSpeed = 1.0;

  // Set to false to disable rotating
  this.enableRotate = true;
  this.rotateSpeed = 1.0;

  // Set to false to disable panning
  this.enablePan = true;
  this.keyPanSpeed = 7.0; // pixels moved per arrow key push

  // Set to true to automatically rotate around the target
  // If auto-rotate is enabled, you must call controls.update() in your animation loop
  this.autoRotate = false;
  this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60

  // Set to false to disable use of the keys
  this.enableKeys = true;

  // The four arrow keys
  this.keys = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };

  // Mouse buttons
  this.mouseButtons = { ORBIT: THREE.MOUSE.LEFT, ZOOM: THREE.MOUSE.MIDDLE, PAN: THREE.MOUSE.RIGHT };

  // for reset
  this.target0 = this.target.clone();
  this.position0 = this.object.position.clone();
  this.zoom0 = this.object.zoom;

  //
  // public methods
  //

  this.getPolarAngle = function () {

    return phi;
  };

  this.getAzimuthalAngle = function () {

    return theta;
  };

  this.reset = function () {

    scope.target.copy(scope.target0);
    scope.object.position.copy(scope.position0);
    scope.object.zoom = scope.zoom0;

    scope.object.updateProjectionMatrix();
    scope.dispatchEvent(changeEvent);

    scope.update();

    state = STATE.NONE;
  };

  // this method is exposed, but perhaps it would be better if we can make it private...
  this.update = function () {

    var offset = new THREE.Vector3();

    // so camera.up is the orbit axis
    var quat = new THREE.Quaternion().setFromUnitVectors(object.up, new THREE.Vector3(0, 1, 0));
    var quatInverse = quat.clone().inverse();

    var lastPosition = new THREE.Vector3();
    var lastQuaternion = new THREE.Quaternion();

    return function () {

      var position = scope.object.position;

      offset.copy(position).sub(scope.target);

      // rotate offset to "y-axis-is-up" space
      offset.applyQuaternion(quat);

      // angle from z-axis around y-axis
      spherical.setFromVector3(offset);

      if (scope.autoRotate && state === STATE.NONE) {

        rotateLeft(getAutoRotationAngle());
      }

      spherical.theta += sphericalDelta.theta;
      spherical.phi += sphericalDelta.phi;

      // restrict theta to be between desired limits
      spherical.theta = Math.max(scope.minAzimuthAngle, Math.min(scope.maxAzimuthAngle, spherical.theta));

      // restrict phi to be between desired limits
      spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));

      spherical.makeSafe();

      spherical.radius *= scale;

      // restrict radius to be between desired limits
      spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));

      // move target to panned location
      scope.target.add(panOffset);

      offset.setFromSpherical(spherical);

      // rotate offset back to "camera-up-vector-is-up" space
      offset.applyQuaternion(quatInverse);

      position.copy(scope.target).add(offset);

      scope.object.lookAt(scope.target);

      if (scope.enableDamping === true) {

        sphericalDelta.theta *= 1 - scope.dampingFactor;
        sphericalDelta.phi *= 1 - scope.dampingFactor;
      } else {

        sphericalDelta.set(0, 0, 0);
      }

      scale = 1;
      panOffset.set(0, 0, 0);

      // update condition is:
      // min(camera displacement, camera rotation in radians)^2 > EPS
      // using small-angle approximation cos(x/2) = 1 - x^2 / 8

      if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {

        scope.dispatchEvent(changeEvent);

        lastPosition.copy(scope.object.position);
        lastQuaternion.copy(scope.object.quaternion);
        zoomChanged = false;

        return true;
      }

      return false;
    };
  }();

  this.dispose = function () {

    scope.domElement.removeEventListener('contextmenu', onContextMenu, false);
    scope.domElement.removeEventListener('mousedown', onMouseDown, false);
    scope.domElement.removeEventListener('mousewheel', onMouseWheel, false);
    scope.domElement.removeEventListener('MozMousePixelScroll', onMouseWheel, false); // firefox

    scope.domElement.removeEventListener('touchstart', onTouchStart, false);
    scope.domElement.removeEventListener('touchend', onTouchEnd, false);
    scope.domElement.removeEventListener('touchmove', onTouchMove, false);

    document.removeEventListener('mousemove', onMouseMove, false);
    document.removeEventListener('mouseup', onMouseUp, false);
    document.removeEventListener('mouseout', onMouseUp, false);

    // window.removeEventListener( 'keydown', onKeyDown, false );

    //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
  };

  //
  // internals
  //

  var scope = this;

  var changeEvent = { type: 'change' };
  var startEvent = { type: 'start' };
  var endEvent = { type: 'end' };

  var STATE = { NONE: -1, ROTATE: 0, DOLLY: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_DOLLY: 4, TOUCH_PAN: 5 };

  var state = STATE.NONE;

  var EPS = 0.000001;

  // current position in spherical coordinates
  var spherical = new THREE.Spherical();
  var sphericalDelta = new THREE.Spherical();

  var scale = 1;
  var panOffset = new THREE.Vector3();
  var zoomChanged = false;

  var rotateStart = new THREE.Vector2();
  var rotateEnd = new THREE.Vector2();
  var rotateDelta = new THREE.Vector2();

  var panStart = new THREE.Vector2();
  var panEnd = new THREE.Vector2();
  var panDelta = new THREE.Vector2();

  var dollyStart = new THREE.Vector2();
  var dollyEnd = new THREE.Vector2();
  var dollyDelta = new THREE.Vector2();

  function getAutoRotationAngle() {

    return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
  }

  function getZoomScale() {

    return Math.pow(0.95, scope.zoomSpeed);
  }

  function rotateLeft(angle) {

    sphericalDelta.theta -= angle;
  }

  function rotateUp(angle) {

    sphericalDelta.phi -= angle;
  }

  var panLeft = function () {

    var v = new THREE.Vector3();

    return function panLeft(distance, objectMatrix) {

      v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
      v.multiplyScalar(-distance);

      panOffset.add(v);
    };
  }();

  var panUp = function () {

    var v = new THREE.Vector3();

    return function panUp(distance, objectMatrix) {

      v.setFromMatrixColumn(objectMatrix, 1); // get Y column of objectMatrix
      v.multiplyScalar(distance);

      panOffset.add(v);
    };
  }();

  // deltaX and deltaY are in pixels; right and down are positive
  var pan = function () {

    var offset = new THREE.Vector3();

    return function (deltaX, deltaY) {

      var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

      if (scope.object instanceof THREE.PerspectiveCamera) {

        // perspective
        var position = scope.object.position;
        offset.copy(position).sub(scope.target);
        var targetDistance = offset.length();

        // half of the fov is center to top of screen
        targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);

        // we actually don't use screenWidth, since perspective camera is fixed to screen height
        panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
        panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
      } else if (scope.object instanceof THREE.OrthographicCamera) {

        // orthographic
        panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
        panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
      } else {

        // camera neither orthographic nor perspective
        console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
        scope.enablePan = false;
      }
    };
  }();

  function dollyIn(dollyScale) {

    if (scope.object instanceof THREE.PerspectiveCamera) {

      scale /= dollyScale;
    } else if (scope.object instanceof THREE.OrthographicCamera) {

      scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
      scope.object.updateProjectionMatrix();
      zoomChanged = true;
    } else {

      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
      scope.enableZoom = false;
    }
  }

  function dollyOut(dollyScale) {

    if (scope.object instanceof THREE.PerspectiveCamera) {

      scale *= dollyScale;
    } else if (scope.object instanceof THREE.OrthographicCamera) {

      scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
      scope.object.updateProjectionMatrix();
      zoomChanged = true;
    } else {

      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
      scope.enableZoom = false;
    }
  }

  //
  // event callbacks - update the object state
  //

  function handleMouseDownRotate(event) {

    //console.log( 'handleMouseDownRotate' );

    rotateStart.set(event.clientX, event.clientY);
  }

  function handleMouseDownDolly(event) {

    //console.log( 'handleMouseDownDolly' );

    dollyStart.set(event.clientX, event.clientY);
  }

  function handleMouseDownPan(event) {

    //console.log( 'handleMouseDownPan' );

    panStart.set(event.clientX, event.clientY);
  }

  function handleMouseMoveRotate(event) {

    //console.log( 'handleMouseMoveRotate' );

    rotateEnd.set(event.clientX, event.clientY);
    rotateDelta.subVectors(rotateEnd, rotateStart);

    var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

    // rotating across whole screen goes 360 degrees around
    rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);

    // rotating up and down along whole screen attempts to go 360, but limited to 180
    rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);

    rotateStart.copy(rotateEnd);

    scope.update();
  }

  function handleMouseMoveDolly(event) {

    //console.log( 'handleMouseMoveDolly' );

    dollyEnd.set(event.clientX, event.clientY);

    dollyDelta.subVectors(dollyEnd, dollyStart);

    if (dollyDelta.y > 0) {

      dollyIn(getZoomScale());
    } else if (dollyDelta.y < 0) {

      dollyOut(getZoomScale());
    }

    dollyStart.copy(dollyEnd);

    scope.update();
  }

  function handleMouseMovePan(event) {

    //console.log( 'handleMouseMovePan' );

    panEnd.set(event.clientX, event.clientY);

    panDelta.subVectors(panEnd, panStart);

    pan(panDelta.x, panDelta.y);

    panStart.copy(panEnd);

    scope.update();
  }

  function handleMouseUp(event) {

    //console.log( 'handleMouseUp' );

  }

  function handleMouseWheel(event) {

    //console.log( 'handleMouseWheel' );

    var delta = 0;

    if (event.wheelDelta !== undefined) {

      // WebKit / Opera / Explorer 9

      delta = event.wheelDelta;
    } else if (event.detail !== undefined) {

      // Firefox

      delta = -event.detail;
    }

    if (delta > 0) {

      dollyOut(getZoomScale());
    } else if (delta < 0) {

      dollyIn(getZoomScale());
    }

    scope.update();
  }

  function handleKeyDown(event) {

    //console.log( 'handleKeyDown' );

    switch (event.keyCode) {

      case scope.keys.UP:
        pan(0, scope.keyPanSpeed);
        scope.update();
        break;

      case scope.keys.BOTTOM:
        pan(0, -scope.keyPanSpeed);
        scope.update();
        break;

      case scope.keys.LEFT:
        pan(scope.keyPanSpeed, 0);
        scope.update();
        break;

      case scope.keys.RIGHT:
        pan(-scope.keyPanSpeed, 0);
        scope.update();
        break;

    }
  }

  function handleTouchStartRotate(event) {

    //console.log( 'handleTouchStartRotate' );

    rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
  }

  function handleTouchStartDolly(event) {

    //console.log( 'handleTouchStartDolly' );

    var dx = event.touches[0].pageX - event.touches[1].pageX;
    var dy = event.touches[0].pageY - event.touches[1].pageY;

    var distance = Math.sqrt(dx * dx + dy * dy);

    dollyStart.set(0, distance);
  }

  function handleTouchStartPan(event) {

    //console.log( 'handleTouchStartPan' );

    panStart.set(event.touches[0].pageX, event.touches[0].pageY);
  }

  function handleTouchMoveRotate(event) {

    //console.log( 'handleTouchMoveRotate' );

    rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
    rotateDelta.subVectors(rotateEnd, rotateStart);

    var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

    // rotating across whole screen goes 360 degrees around
    rotateLeft(2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed);

    // rotating up and down along whole screen attempts to go 360, but limited to 180
    rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed);

    rotateStart.copy(rotateEnd);

    scope.update();
  }

  function handleTouchMoveDolly(event) {

    //console.log( 'handleTouchMoveDolly' );

    var dx = event.touches[0].pageX - event.touches[1].pageX;
    var dy = event.touches[0].pageY - event.touches[1].pageY;

    var distance = Math.sqrt(dx * dx + dy * dy);

    dollyEnd.set(0, distance);

    dollyDelta.subVectors(dollyEnd, dollyStart);

    if (dollyDelta.y > 0) {

      dollyOut(getZoomScale());
    } else if (dollyDelta.y < 0) {

      dollyIn(getZoomScale());
    }

    dollyStart.copy(dollyEnd);

    scope.update();
  }

  function handleTouchMovePan(event) {

    //console.log( 'handleTouchMovePan' );

    panEnd.set(event.touches[0].pageX, event.touches[0].pageY);

    panDelta.subVectors(panEnd, panStart);

    pan(panDelta.x, panDelta.y);

    panStart.copy(panEnd);

    scope.update();
  }

  function handleTouchEnd(event) {}

  //console.log( 'handleTouchEnd' );

  //
  // event handlers - FSM: listen for events and reset state
  //

  function onMouseDown(event) {

    if (scope.enabled === false) return;

    event.preventDefault();

    if (event.button === scope.mouseButtons.ORBIT) {

      if (scope.enableRotate === false) return;

      handleMouseDownRotate(event);

      state = STATE.ROTATE;
    } else if (event.button === scope.mouseButtons.ZOOM) {

      if (scope.enableZoom === false) return;

      handleMouseDownDolly(event);

      state = STATE.DOLLY;
    } else if (event.button === scope.mouseButtons.PAN) {

      if (scope.enablePan === false) return;

      handleMouseDownPan(event);

      state = STATE.PAN;
    }

    if (state !== STATE.NONE) {

      document.addEventListener('mousemove', onMouseMove, false);
      document.addEventListener('mouseup', onMouseUp, false);
      document.addEventListener('mouseout', onMouseUp, false);

      scope.dispatchEvent(startEvent);
    }
  }

  function onMouseMove(event) {

    if (scope.enabled === false) return;

    event.preventDefault();

    if (state === STATE.ROTATE) {

      if (scope.enableRotate === false) return;

      handleMouseMoveRotate(event);
    } else if (state === STATE.DOLLY) {

      if (scope.enableZoom === false) return;

      handleMouseMoveDolly(event);
    } else if (state === STATE.PAN) {

      if (scope.enablePan === false) return;

      handleMouseMovePan(event);
    }
  }

  function onMouseUp(event) {

    if (scope.enabled === false) return;

    handleMouseUp(event);

    document.removeEventListener('mousemove', onMouseMove, false);
    document.removeEventListener('mouseup', onMouseUp, false);
    document.removeEventListener('mouseout', onMouseUp, false);

    scope.dispatchEvent(endEvent);

    state = STATE.NONE;
  }

  function onMouseWheel(event) {

    if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) return;

    event.preventDefault();
    event.stopPropagation();

    handleMouseWheel(event);

    scope.dispatchEvent(startEvent); // not sure why these are here...
    scope.dispatchEvent(endEvent);
  }

  function onKeyDown(event) {

    if (scope.enabled === false || scope.enableKeys === false || scope.enablePan === false) return;

    handleKeyDown(event);
  }

  function onTouchStart(event) {

    if (scope.enabled === false) return;

    switch (event.touches.length) {

      case 1:
        // one-fingered touch: rotate

        if (scope.enableRotate === false) return;

        handleTouchStartRotate(event);

        state = STATE.TOUCH_ROTATE;

        break;

      case 2:
        // two-fingered touch: dolly

        if (scope.enableZoom === false) return;

        handleTouchStartDolly(event);

        state = STATE.TOUCH_DOLLY;

        break;

      case 3:
        // three-fingered touch: pan

        if (scope.enablePan === false) return;

        handleTouchStartPan(event);

        state = STATE.TOUCH_PAN;

        break;

      default:

        state = STATE.NONE;

    }

    if (state !== STATE.NONE) {

      scope.dispatchEvent(startEvent);
    }
  }

  function onTouchMove(event) {

    if (scope.enabled === false) return;

    event.preventDefault();
    event.stopPropagation();

    switch (event.touches.length) {

      case 1:
        // one-fingered touch: rotate

        if (scope.enableRotate === false) return;
        if (state !== STATE.TOUCH_ROTATE) return; // is this needed?...

        handleTouchMoveRotate(event);

        break;

      case 2:
        // two-fingered touch: dolly

        if (scope.enableZoom === false) return;
        if (state !== STATE.TOUCH_DOLLY) return; // is this needed?...

        handleTouchMoveDolly(event);

        break;

      case 3:
        // three-fingered touch: pan

        if (scope.enablePan === false) return;
        if (state !== STATE.TOUCH_PAN) return; // is this needed?...

        handleTouchMovePan(event);

        break;

      default:

        state = STATE.NONE;

    }
  }

  function onTouchEnd(event) {

    if (scope.enabled === false) return;

    handleTouchEnd(event);

    scope.dispatchEvent(endEvent);

    state = STATE.NONE;
  }

  function onContextMenu(event) {

    event.preventDefault();
  }

  //

  scope.domElement.addEventListener('contextmenu', onContextMenu, false);

  scope.domElement.addEventListener('mousedown', onMouseDown, false);
  scope.domElement.addEventListener('mousewheel', onMouseWheel, false);
  scope.domElement.addEventListener('MozMousePixelScroll', onMouseWheel, false); // firefox

  scope.domElement.addEventListener('touchstart', onTouchStart, false);
  scope.domElement.addEventListener('touchend', onTouchEnd, false);
  scope.domElement.addEventListener('touchmove', onTouchMove, false);

  // window.addEventListener( 'keydown', onKeyDown, false );

  // force an update at start

  this.update();
} /* eslint-disable */
;

OrbitControls.prototype = (0, _create2.default)(THREE.EventDispatcher.prototype);
OrbitControls.prototype.constructor = OrbitControls;

(0, _defineProperties2.default)(OrbitControls.prototype, {

  center: {

    get: function get() {

      console.warn('THREE.OrbitControls: .center has been renamed to .target');
      return this.target;
    }

  },

  // backward compatibility

  noZoom: {

    get: function get() {

      console.warn('THREE.OrbitControls: .noZoom has been deprecated. Use .enableZoom instead.');
      return !this.enableZoom;
    },

    set: function set(value) {

      console.warn('THREE.OrbitControls: .noZoom has been deprecated. Use .enableZoom instead.');
      this.enableZoom = !value;
    }

  },

  noRotate: {

    get: function get() {

      console.warn('THREE.OrbitControls: .noRotate has been deprecated. Use .enableRotate instead.');
      return !this.enableRotate;
    },

    set: function set(value) {

      console.warn('THREE.OrbitControls: .noRotate has been deprecated. Use .enableRotate instead.');
      this.enableRotate = !value;
    }

  },

  noPan: {

    get: function get() {

      console.warn('THREE.OrbitControls: .noPan has been deprecated. Use .enablePan instead.');
      return !this.enablePan;
    },

    set: function set(value) {

      console.warn('THREE.OrbitControls: .noPan has been deprecated. Use .enablePan instead.');
      this.enablePan = !value;
    }

  },

  noKeys: {

    get: function get() {

      console.warn('THREE.OrbitControls: .noKeys has been deprecated. Use .enableKeys instead.');
      return !this.enableKeys;
    },

    set: function set(value) {

      console.warn('THREE.OrbitControls: .noKeys has been deprecated. Use .enableKeys instead.');
      this.enableKeys = !value;
    }

  },

  staticMoving: {

    get: function get() {

      console.warn('THREE.OrbitControls: .staticMoving has been deprecated. Use .enableDamping instead.');
      return !this.constraint.enableDamping;
    },

    set: function set(value) {

      console.warn('THREE.OrbitControls: .staticMoving has been deprecated. Use .enableDamping instead.');
      this.constraint.enableDamping = !value;
    }

  },

  dynamicDampingFactor: {

    get: function get() {

      console.warn('THREE.OrbitControls: .dynamicDampingFactor has been renamed. Use .dampingFactor instead.');
      return this.constraint.dampingFactor;
    },

    set: function set(value) {

      console.warn('THREE.OrbitControls: .dynamicDampingFactor has been renamed. Use .dampingFactor instead.');
      this.constraint.dampingFactor = value;
    }

  }

});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MTLLoader;

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Loads a Wavefront .mtl file specifying materials
 *
 * @author angelxuanchang
 */

function MTLLoader(manager) {

  this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;
} /* eslint-disable */
;

MTLLoader.prototype = {

  constructor: MTLLoader,

  load: function load(url, onLoad, onProgress, onError) {

    var scope = this;

    var loader = new THREE.XHRLoader(this.manager);
    loader.setPath(this.path);
    loader.load(url, function (text) {

      onLoad(scope.parse(text));
    }, onProgress, onError);
  },

  setPath: function setPath(value) {

    this.path = value;
  },

  setBaseUrl: function setBaseUrl(value) {

    // TODO: Merge with setPath()? Or rename to setTexturePath?

    this.baseUrl = value;
  },

  setCrossOrigin: function setCrossOrigin(value) {

    this.crossOrigin = value;
  },

  setMaterialOptions: function setMaterialOptions(value) {

    this.materialOptions = value;
  },

  /**
   * Parses loaded MTL file
   * @param text - Content of MTL file
   * @return {THREE.MTLLoader.MaterialCreator}
   */
  parse: function parse(text) {

    var lines = text.split("\n");
    var info = {};
    var delimiter_pattern = /\s+/;
    var materialsInfo = {};

    for (var i = 0; i < lines.length; i++) {

      var line = lines[i];
      line = line.trim();

      if (line.length === 0 || line.charAt(0) === '#') {

        // Blank line or comment ignore
        continue;
      }

      var pos = line.indexOf(' ');

      var key = pos >= 0 ? line.substring(0, pos) : line;
      key = key.toLowerCase();

      var value = pos >= 0 ? line.substring(pos + 1) : "";
      value = value.trim();

      if (key === "newmtl") {

        // New material

        info = { name: value };
        materialsInfo[value] = info;
      } else if (info) {

        if (key === "ka" || key === "kd" || key === "ks") {

          var ss = value.split(delimiter_pattern, 3);
          info[key] = [parseFloat(ss[0]), parseFloat(ss[1]), parseFloat(ss[2])];
        } else {

          info[key] = value;
        }
      }
    }

    var materialCreator = new MTLLoader.MaterialCreator(this.baseUrl, this.materialOptions);
    materialCreator.setCrossOrigin(this.crossOrigin);
    materialCreator.setManager(this.manager);
    materialCreator.setMaterials(materialsInfo);
    return materialCreator;
  }

};

/**
 * Create a new THREE-MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        THREE.FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        THREE.RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */

MTLLoader.MaterialCreator = function (baseUrl, options) {

  this.baseUrl = baseUrl;
  this.options = options;
  this.materialsInfo = {};
  this.materials = {};
  this.materialsArray = [];
  this.nameLookup = {};

  this.side = this.options && this.options.side ? this.options.side : THREE.FrontSide;
  this.wrap = this.options && this.options.wrap ? this.options.wrap : THREE.RepeatWrapping;
};

MTLLoader.MaterialCreator.prototype = {

  constructor: MTLLoader.MaterialCreator,

  setCrossOrigin: function setCrossOrigin(value) {

    this.crossOrigin = value;
  },

  setManager: function setManager(value) {

    this.manager = value;
  },

  setMaterials: function setMaterials(materialsInfo) {

    this.materialsInfo = this.convert(materialsInfo);
    this.materials = {};
    this.materialsArray = [];
    this.nameLookup = {};
  },

  convert: function convert(materialsInfo) {

    if (!this.options) return materialsInfo;

    var converted = {};

    for (var mn in materialsInfo) {

      // Convert materials info into normalized form based on options

      var mat = materialsInfo[mn];

      var covmat = {};

      converted[mn] = covmat;

      for (var prop in mat) {

        var save = true;
        var value = mat[prop];
        var lprop = prop.toLowerCase();

        switch (lprop) {

          case 'kd':
          case 'ka':
          case 'ks':

            // Diffuse color (color under white light) using RGB values

            if (this.options && this.options.normalizeRGB) {

              value = [value[0] / 255, value[1] / 255, value[2] / 255];
            }

            if (this.options && this.options.ignoreZeroRGBs) {

              if (value[0] === 0 && value[1] === 0 && value[1] === 0) {

                // ignore

                save = false;
              }
            }

            break;

          default:

            break;
        }

        if (save) {

          covmat[lprop] = value;
        }
      }
    }

    return converted;
  },

  preload: function preload() {

    for (var mn in this.materialsInfo) {

      this.create(mn);
    }
  },

  getIndex: function getIndex(materialName) {

    return this.nameLookup[materialName];
  },

  getAsArray: function getAsArray() {

    var index = 0;

    for (var mn in this.materialsInfo) {

      this.materialsArray[index] = this.create(mn);
      this.nameLookup[mn] = index;
      index++;
    }

    return this.materialsArray;
  },

  create: function create(materialName) {

    if (this.materials[materialName] === undefined) {

      this.createMaterial_(materialName);
    }

    return this.materials[materialName];
  },

  createMaterial_: function createMaterial_(materialName) {

    // Create material

    var mat = this.materialsInfo[materialName];
    var params = {

      name: materialName,
      side: this.side

    };

    for (var prop in mat) {

      var value = mat[prop];

      if (value === '') continue;

      switch (prop.toLowerCase()) {

        // Ns is material specular exponent

        case 'kd':

          // Diffuse color (color under white light) using RGB values

          params['color'] = new THREE.Color().fromArray(value);

          break;

        case 'ks':

          // Specular color (color when light is reflected from shiny surface) using RGB values
          params['specular'] = new THREE.Color().fromArray(value);

          break;

        case 'map_kd':

          // Diffuse texture map

          params['map'] = this.loadTexture(this.baseUrl + value);
          params['map'].wrapS = this.wrap;
          params['map'].wrapT = this.wrap;

          break;

        case 'ns':

          // The specular exponent (defines the focus of the specular highlight)
          // A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.

          params['shininess'] = parseFloat(value);

          break;

        case 'd':

          if (value < 1) {

            params['opacity'] = value;
            params['transparent'] = true;
          }

          break;

        case 'Tr':

          if (value > 0) {

            params['opacity'] = 1 - value;
            params['transparent'] = true;
          }

          break;

        case 'map_bump':
        case 'bump':

          // Bump texture map

          if (params['bumpMap']) break; // Avoid loading twice.

          params['bumpMap'] = this.loadTexture(this.baseUrl + value);
          params['bumpMap'].wrapS = this.wrap;
          params['bumpMap'].wrapT = this.wrap;

          break;

        default:
          break;

      }
    }

    this.materials[materialName] = new THREE.MeshPhongMaterial(params);
    return this.materials[materialName];
  },

  loadTexture: function loadTexture(url, mapping, onLoad, onProgress, onError) {

    var texture;
    var loader = THREE.Loader.Handlers.get(url);
    var manager = this.manager !== undefined ? this.manager : THREE.DefaultLoadingManager;

    if (loader === null) {

      loader = new THREE.TextureLoader(manager);
    }

    if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
    texture = loader.load(url, onLoad, onProgress, onError);

    if (mapping !== undefined) texture.mapping = mapping;

    return texture;
  }

};

// warn: THREE.EventDispatcher: .apply is deprecated,
// just inherit or Object.assign the prototype to mix-in.
// THREE.EventDispatcher.prototype.apply( MTLLoader.prototype );
for (var k in THREE.EventDispatcher.prototype) {
  MTLLoader.prototype[k] = THREE.EventDispatcher.prototype[k];
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OBJLoader;

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @author mrdoob / http://mrdoob.com/
 */

function OBJLoader(manager) {

  this.manager = manager !== undefined ? manager : THREE.DefaultLoadingManager;

  this.materials = null;
} /* eslint-disable */
;

OBJLoader.prototype = {

  constructor: OBJLoader,

  load: function load(url, onLoad, onProgress, onError) {

    var scope = this;

    var loader = new THREE.XHRLoader(scope.manager);
    loader.setPath(this.path);
    loader.load(url, function (text) {

      onLoad(scope.parse(text));
    }, onProgress, onError);
  },

  setPath: function setPath(value) {

    this.path = value;
  },

  setMaterials: function setMaterials(materials) {

    this.materials = materials;
  },

  parse: function parse(text) {

    console.time('OBJLoader');

    var objects = [];
    var object;
    var foundObjects = false;
    var vertices = [];
    var normals = [];
    var uvs = [];

    function addObject(name) {

      var geometry = {
        vertices: [],
        normals: [],
        uvs: []
      };

      var material = {
        name: '',
        smooth: true
      };

      object = {
        name: name,
        geometry: geometry,
        material: material
      };

      objects.push(object);
    }

    function parseVertexIndex(value) {

      var index = parseInt(value);

      return (index >= 0 ? index - 1 : index + vertices.length / 3) * 3;
    }

    function parseNormalIndex(value) {

      var index = parseInt(value);

      return (index >= 0 ? index - 1 : index + normals.length / 3) * 3;
    }

    function parseUVIndex(value) {

      var index = parseInt(value);

      return (index >= 0 ? index - 1 : index + uvs.length / 2) * 2;
    }

    function addVertex(a, b, c) {

      object.geometry.vertices.push(vertices[a], vertices[a + 1], vertices[a + 2], vertices[b], vertices[b + 1], vertices[b + 2], vertices[c], vertices[c + 1], vertices[c + 2]);
    }

    function addNormal(a, b, c) {

      object.geometry.normals.push(normals[a], normals[a + 1], normals[a + 2], normals[b], normals[b + 1], normals[b + 2], normals[c], normals[c + 1], normals[c + 2]);
    }

    function addUV(a, b, c) {

      object.geometry.uvs.push(uvs[a], uvs[a + 1], uvs[b], uvs[b + 1], uvs[c], uvs[c + 1]);
    }

    function addFace(a, b, c, d, ua, ub, uc, ud, na, nb, nc, nd) {

      var ia = parseVertexIndex(a);
      var ib = parseVertexIndex(b);
      var ic = parseVertexIndex(c);
      var id;

      if (d === undefined) {

        addVertex(ia, ib, ic);
      } else {

        id = parseVertexIndex(d);

        addVertex(ia, ib, id);
        addVertex(ib, ic, id);
      }

      if (ua !== undefined) {

        ia = parseUVIndex(ua);
        ib = parseUVIndex(ub);
        ic = parseUVIndex(uc);

        if (d === undefined) {

          addUV(ia, ib, ic);
        } else {

          id = parseUVIndex(ud);

          addUV(ia, ib, id);
          addUV(ib, ic, id);
        }
      }

      if (na !== undefined) {

        ia = parseNormalIndex(na);
        ib = parseNormalIndex(nb);
        ic = parseNormalIndex(nc);

        if (d === undefined) {

          addNormal(ia, ib, ic);
        } else {

          id = parseNormalIndex(nd);

          addNormal(ia, ib, id);
          addNormal(ib, ic, id);
        }
      }
    }

    addObject('');

    // v float float float
    var vertex_pattern = /^v\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/;

    // vn float float float
    var normal_pattern = /^vn\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/;

    // vt float float
    var uv_pattern = /^vt\s+([\d|\.|\+|\-|e|E]+)\s+([\d|\.|\+|\-|e|E]+)/;

    // f vertex vertex vertex ...
    var face_pattern1 = /^f\s+(-?\d+)\s+(-?\d+)\s+(-?\d+)(?:\s+(-?\d+))?/;

    // f vertex/uv vertex/uv vertex/uv ...
    var face_pattern2 = /^f\s+((-?\d+)\/(-?\d+))\s+((-?\d+)\/(-?\d+))\s+((-?\d+)\/(-?\d+))(?:\s+((-?\d+)\/(-?\d+)))?/;

    // f vertex/uv/normal vertex/uv/normal vertex/uv/normal ...
    var face_pattern3 = /^f\s+((-?\d+)\/(-?\d+)\/(-?\d+))\s+((-?\d+)\/(-?\d+)\/(-?\d+))\s+((-?\d+)\/(-?\d+)\/(-?\d+))(?:\s+((-?\d+)\/(-?\d+)\/(-?\d+)))?/;

    // f vertex//normal vertex//normal vertex//normal ...
    var face_pattern4 = /^f\s+((-?\d+)\/\/(-?\d+))\s+((-?\d+)\/\/(-?\d+))\s+((-?\d+)\/\/(-?\d+))(?:\s+((-?\d+)\/\/(-?\d+)))?/;

    var object_pattern = /^[og]\s*(.+)?/;

    var smoothing_pattern = /^s\s+(\d+|on|off)/;

    //

    var lines = text.split('\n');

    for (var i = 0; i < lines.length; i++) {

      var line = lines[i];
      line = line.trim();

      var result;

      if (line.length === 0 || line.charAt(0) === '#') {

        continue;
      } else if ((result = vertex_pattern.exec(line)) !== null) {

        // ["v 1.0 2.0 3.0", "1.0", "2.0", "3.0"]

        vertices.push(parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3]));
      } else if ((result = normal_pattern.exec(line)) !== null) {

        // ["vn 1.0 2.0 3.0", "1.0", "2.0", "3.0"]

        normals.push(parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3]));
      } else if ((result = uv_pattern.exec(line)) !== null) {

        // ["vt 0.1 0.2", "0.1", "0.2"]

        uvs.push(parseFloat(result[1]), parseFloat(result[2]));
      } else if ((result = face_pattern1.exec(line)) !== null) {

        // ["f 1 2 3", "1", "2", "3", undefined]

        addFace(result[1], result[2], result[3], result[4]);
      } else if ((result = face_pattern2.exec(line)) !== null) {

        // ["f 1/1 2/2 3/3", " 1/1", "1", "1", " 2/2", "2", "2", " 3/3", "3", "3", undefined, undefined, undefined]

        addFace(result[2], result[5], result[8], result[11], result[3], result[6], result[9], result[12]);
      } else if ((result = face_pattern3.exec(line)) !== null) {

        // ["f 1/1/1 2/2/2 3/3/3", " 1/1/1", "1", "1", "1", " 2/2/2", "2", "2", "2", " 3/3/3", "3", "3", "3", undefined, undefined, undefined, undefined]

        addFace(result[2], result[6], result[10], result[14], result[3], result[7], result[11], result[15], result[4], result[8], result[12], result[16]);
      } else if ((result = face_pattern4.exec(line)) !== null) {

        // ["f 1//1 2//2 3//3", " 1//1", "1", "1", " 2//2", "2", "2", " 3//3", "3", "3", undefined, undefined, undefined]

        addFace(result[2], result[5], result[8], result[11], undefined, undefined, undefined, undefined, result[3], result[6], result[9], result[12]);
      } else if ((result = object_pattern.exec(line)) !== null) {

        // o object_name
        // or
        // g group_name

        var name = result[0].substr(1).trim();

        if (foundObjects === false) {

          foundObjects = true;
          object.name = name;
        } else {

          addObject(name);
        }
      } else if (/^usemtl /.test(line)) {

        // material

        object.material.name = line.substring(7).trim();
      } else if (/^mtllib /.test(line)) {

        // mtl file

      } else if ((result = smoothing_pattern.exec(line)) !== null) {

        // smooth shading

        object.material.smooth = result[1] === "1" || result[1] === "on";
      } else {

        throw new Error("Unexpected line: " + line);
      }
    }

    var container = new THREE.Group();

    for (var i = 0, l = objects.length; i < l; i++) {

      object = objects[i];
      var geometry = object.geometry;

      var buffergeometry = new THREE.BufferGeometry();

      buffergeometry.addAttribute('position', new THREE.BufferAttribute(new Float32Array(geometry.vertices), 3));

      if (geometry.normals.length > 0) {

        buffergeometry.addAttribute('normal', new THREE.BufferAttribute(new Float32Array(geometry.normals), 3));
      } else {

        buffergeometry.computeVertexNormals();
      }

      if (geometry.uvs.length > 0) {

        buffergeometry.addAttribute('uv', new THREE.BufferAttribute(new Float32Array(geometry.uvs), 2));
      }

      var material;

      if (this.materials !== null) {

        material = this.materials.create(object.material.name);
      }

      if (!material) {

        material = new THREE.MeshPhongMaterial();
        material.name = object.material.name;
      }

      material.shading = object.material.smooth ? THREE.SmoothShading : THREE.FlatShading;

      var mesh = new THREE.Mesh(buffergeometry, material);
      mesh.name = object.name;

      container.add(mesh);
    }

    console.timeEnd('OBJLoader');

    return container;
  }

};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gui = __webpack_require__(48);

var gui = _interopRequireWildcard(_gui);

var _Ocean = __webpack_require__(133);

var _Ocean2 = _interopRequireDefault(_Ocean);

var _SF = __webpack_require__(134);

var _SF2 = _interopRequireDefault(_SF);

var _Cube = __webpack_require__(132);

var _Cube2 = _interopRequireDefault(_Cube);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'App',
  components: {
    Cube: _Cube2.default,
    Ocean: _Ocean2.default,
    sf03: _SF2.default
  },

  data: function data() {
    var uiSetup = gui.setupPanel;
    var ui = gui.getModel();
    return {
      textures: ['cobblestone', 'diamond', 'redwool'],
      ui: ui,
      uiSetup: uiSetup,
      size: {
        w: window.innerWidth,
        h: window.innerHeight
      }
    };
  },
  created: function created() {
    var _this = this;

    // hack: loop animation via vue key prop
    setInterval(function () {
      _this.ui.movemSysKey += 1;
    }, 15000);
  }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _three = __webpack_require__(1);

var _ = __webpack_require__(13);

//
//
//
//
//
//
//

exports.default = {
  name: 'cube',
  mixins: [_.Object3D],
  props: { size: Number, texture: String },

  data: function data() {
    var url = __webpack_require__(172)("./" + this.texture + '.png');
    var map = new _three.TextureLoader().load(url);
    return { material: { map: map } };
  }
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

var _ = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// http://threejs.org/examples/#webgl_geometry_dynamic
//
//
//
//
//
//
//

/* global requestAnimationFrame */
exports.default = {
  name: 'Ocean',
  mixins: [_.Object3D],

  data: function data() {
    return { ocean: null };
  },
  created: function created() {
    this.ocean = this.createOcean();
  },


  methods: {
    createOcean: function createOcean() {
      var geometry = new THREE.PlaneGeometry(10000, 10000, 40, 40);
      geometry.rotateX(-Math.PI / 2);
      for (var i = 0, l = geometry.vertices.length; i < l; i++) {
        geometry.vertices[i].y = 10 * Math.sin(i / 2);
      }

      var texture = new THREE.TextureLoader().load(__webpack_require__(127));
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(5, 5);
      var material = new THREE.MeshBasicMaterial({ color: 0x0044ff, map: texture });

      var mesh = new THREE.Mesh(geometry, material);
      mesh.name = 'Ocean';
      return mesh;
    },
    animate: function animate(tt) {
      var geometry = this.ocean.geometry;

      for (var i = 0, l = geometry.vertices.length; i < l; i++) {
        geometry.vertices[i].y = 10 * Math.sin(i / 5 + (tt + i) / 7);
      }
      geometry.verticesNeedUpdate = true;
    }
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

var _ = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'SF03',
  mixins: [_.Object3D],

  data: function data() {
    return { pos: null, body: null };
  },


  /* eslint-disable */
  created: function created() {
    var _this = this;

    // todo: better code
    var mtlLoader = new _.MTLLoader();
    mtlLoader.setBaseUrl('static/threex/spaceships/');
    mtlLoader.setPath('static/threex/spaceships/');
    mtlLoader.load('SpaceFighter03.mtl', function (materials) {
      materials.preload();
      var objLoader = new _.OBJLoader();
      objLoader.setMaterials(materials);
      objLoader.setPath('static/threex/spaceships/');
      objLoader.load('SpaceFighter03.obj', function (group) {
        var body = group.children[0];
        body.material.color.set(0xffffff);
        _this.body = body;
      });
    });

    var detonation = this.generateDetonation();
    this.detonation1 = detonation;
    this.detonation2 = detonation.clone();

    var shoot = this.generateShoot();
    this.shoot1 = shoot;
    this.shoot2 = shoot.clone();
  },


  methods: {
    animate: function animate(tt) {
      this.pos = { y: Math.sin(tt) };
    },
    generateDetonation: function generateDetonation() {
      var texture = new THREE.TextureLoader().load(__webpack_require__(131));
      var geometry = new THREE.PlaneGeometry(1, 1);
      var material = new THREE.MeshBasicMaterial({
        color: 0x00ffff,
        map: texture,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        opacity: 2,
        depthWrite: false,
        transparent: true
      });
      var detonation = new THREE.Mesh(geometry, material);
      detonation.scale.multiplyScalar(4);
      return detonation;
    },
    generateShoot: function generateShoot() {
      var canvas = this.generateShootCanvas();
      var texture = new THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new THREE.MeshBasicMaterial({
        color: 0xffaacc,
        map: texture,
        side: THREE.DoubleSide,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        transparent: true
      });

      var container = new THREE.Object3D();
      container.rotateY(Math.PI / 2);
      container.scale.multiplyScalar(4);
      var nPlanes = 4;
      for (var i = 0; i < nPlanes; i++) {
        var geometry = new THREE.PlaneGeometry(1, 1);
        var mesh = new THREE.Mesh(geometry, material);
        mesh.material = material;
        mesh.rotateX(i * Math.PI / nPlanes);
        container.add(mesh);
      }
      return container;
    },
    generateShootCanvas: function generateShootCanvas() {
      // init canvas
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 16;
      canvas.height = 64;
      // set gradient
      var gradient = context.createRadialGradient(canvas.width / 2, canvas.height / 2, 0, canvas.width / 2, canvas.height / 2, canvas.width / 2);
      gradient.addColorStop(0, 'rgba(255,255,255,1)');
      gradient.addColorStop(0.5, 'rgba(192,192,192,1)');
      gradient.addColorStop(0.8, 'rgba(128,128,128,0.7)');
      gradient.addColorStop(1, 'rgba(0,0,0,0)');

      // fill the rectangle
      context.fillStyle = gradient;
      context.fillRect(0, 0, canvas.width, canvas.height);
      // return the just built canvas
      return canvas;
    }
  }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Base = __webpack_require__(12);

var _Base2 = _interopRequireDefault(_Base);

var _three = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global requestAnimationFrame */
/* global cancelAnimationFrame */
exports.default = {
  name: 'Animation',
  mixins: [_Base2.default],

  props: {
    blocked: { type: Boolean },
    paused: { type: Boolean },
    speed: { type: Number, default: 1 },
    fn: { type: Function, required: true }
  },

  data: function data() {
    return {
      clock: new _three.Clock(!this.paused),
      ht: 0,
      tt: 0,
      frame: null
    };
  },
  mounted: function mounted() {
    this.begin();
  },
  beforeDestroy: function beforeDestroy() {
    this.end();
  },


  watch: {
    paused: function paused(v) {
      if (v) {
        this.clock.stop();
      } else {
        this.clock.start();
      }
    }
  },

  methods: {
    begin: function begin() {
      this.frame = requestAnimationFrame(this.begin);
      var dt = this.clock.getDelta();
      dt *= this.speed;
      this.tt += dt;
      this.ht += dt;
      if (!this.blocked) {
        this.fn(this.tt, this.ht);
        this.ht = 0;
      }
    },
    end: function end() {
      this.clock.stop();
      if (this.frame) {
        cancelAnimationFrame(this.frame);
      }
    }
  }
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _three = __webpack_require__(1);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//

exports.default = {
  name: 'AudioListener',
  mixins: [_Object3D2.default],
  components: { Object3D: _Object3D2.default },

  inject: [].concat((0, _toConsumableArray3.default)(_Object3D2.default.inject), ['global']),

  data: function data() {
    var listener = new _three.AudioListener();
    this.global.audioListener = listener; // fixme
    return { listener: listener };
  }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(30);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//

exports.default = {
  name: 'Base',

  methods: {
    dispatchEvent: function dispatchEvent(name, detail) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
      var e = new CustomEvent(name, (0, _extends3.default)({
        detail: detail,
        bubbles: true,
        cancelable: true
      }, options));
      return this.$el.dispatchEvent(e);
    }
  }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _three = __webpack_require__(1);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Camera',
  mixins: [_Object3D2.default],

  inject: [].concat((0, _toConsumableArray3.default)(_Object3D2.default.inject), ['global']),

  props: {
    obj: { type: Object }
  },

  data: function data() {
    var curObj = this.obj;

    var _global$rendererSize = this.global.rendererSize,
        w = _global$rendererSize.w,
        h = _global$rendererSize.h; // fixme

    if (!curObj) {
      curObj = new _three.PerspectiveCamera(75, w / h, 0.1, 1000);
    }
    curObj.name = curObj.name || curObj.type;

    return { curObj: curObj };
  },
  mounted: function mounted() {
    this.global.camera = this.curObj;
  }
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  name: 'Light',
  mixins: [_Object3D2.default],

  props: {
    hex: Number,
    intensity: Number
  },

  data: function data() {
    var curObj = this.obj;
    if (!curObj) {
      curObj = new THREE.DirectionalLight(this.hex, this.intensity);
    }
    curObj.name = curObj.name || curObj.type;
    return { curObj: curObj };
  }
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(14);

var _assign2 = _interopRequireDefault(_assign);

var _Base = __webpack_require__(12);

var _Base2 = _interopRequireDefault(_Base);

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Object3D',
  mixins: [_Base2.default],

  provide: function provide() {
    return {
      parentObj: this.curObj
    };
  },


  inject: ['parentObj'],

  props: {
    name: { type: String },
    type: { type: String, default: 'Object3D' },
    obj: { type: Object },
    scale: { type: [Object, Number] }, // { x, y, z }
    position: { type: Object }, // { x, y, z }
    rotation: { type: Object // { x, y, z }
    } },

  watch: {
    scale: {
      deep: true,
      handler: function handler(v) {
        this.setScale(v);
      }
    },
    position: {
      deep: true,
      handler: function handler(v) {
        (0, _assign2.default)(this.curObj.position, v);
      }
    },
    rotation: {
      deep: true,
      handler: function handler(v) {
        (0, _assign2.default)(this.curObj.rotation, v);
      }
    }
  },

  data: function data() {
    // fix vue 2.0 `Avoid mutating a prop directly since the value will be overwritten
    // whenever the parent component re-renders. Instead, use a data or computed
    // property based on the prop's value.`
    // https://dotdev.co/peeking-into-vue-js-2-part-1-b457e60c88c6#.918arzkow
    var curObj = this.obj;

    // this.obj = new Object3D() // holder
    if (!curObj) {
      curObj = new THREE[this.type]();
    }

    // fix vue 2.0 `this.constructor.name` becomes `VueComponent`
    // curObj.name = curObj.name || this.constructor.name
    curObj.name = this.name || curObj.name || curObj.type;

    return { curObj: curObj };
  },


  // ready => mounted + (nextTick?)
  // http://rc.vuejs.org/guide/migration.html#ready-deprecated
  mounted: function mounted() {
    this.setScale(this.scale);
    (0, _assign2.default)(this.curObj.position, this.position);
    (0, _assign2.default)(this.curObj.rotation, this.rotation);
    if (this.parentObj) {
      this.parentObj.add(this.curObj);
    }
  },


  // detached => destroyed + (nextTick?)
  // http://rc.vuejs.org/guide/migration.html#detached-deprecated
  // but we use beforeDestroy to clean up
  beforeDestroy: function beforeDestroy() {
    if (this.parentObj) {
      this.parentObj.remove(this.curObj);
    }
  },


  methods: {
    setScale: function setScale(v) {
      if (v && typeof v === 'number') {
        v = { x: v, y: v, z: v };
      }
      (0, _assign2.default)(this.curObj.scale, v);
    }
  }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _OrbitControls2 = __webpack_require__(50);

var _OrbitControls3 = _interopRequireDefault(_OrbitControls2);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

var _three = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OrbitControls',
  mixins: [_Object3D2.default],
  components: { Object3D: _Object3D2.default },

  inject: [].concat((0, _toConsumableArray3.default)(_Object3D2.default.inject), ['global']),

  data: function data() {
    return {
      controls: null,
      timer: null,
      frame: null
    };
  },
  mounted: function mounted() {
    var domElement = this.global.rendererDom; // fixme
    this.controls = new _OrbitControls3.default(this.curObj, domElement);
    this.timer = new _three.Clock();
    this.frame = this.animate();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.frame) {
      cancelAnimationFrame(this.frame);
    }
    if (this.controls) {
      this.controls.dispose();
    }
  },


  methods: {
    animate: function animate() {
      this.frame = requestAnimationFrame(this.animate);
      this.controls.update(this.timer.getDelta());
    }
  }
}; //
//
//
//
//
//

/* global requestAnimationFrame, cancelAnimationFrame */

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _three = __webpack_require__(1);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  name: 'PositionalAudio',
  mixins: [_Object3D2.default],
  components: { Object3D: _Object3D2.default },

  inject: [].concat((0, _toConsumableArray3.default)(_Object3D2.default.inject), ['global']),

  props: { url: String },

  data: function data() {
    return { audio: null };
  },


  // mounted to ensure audioListener
  mounted: function mounted() {
    var listener = this.global.audioListener; // fixme
    var audio = new _three.PositionalAudio(listener);
    audio.name = 'PositionalAudio';
    this.audio = audio;

    // fixme: r76?
    // https://github.com/mrdoob/three.js/blob/master/examples/misc_sound.html
    // audioLoader.load(props.url, function (buffer) {
    // r75:
    audio.load(this.url);
    audio.autoplay = true;
    audio.setLoop(true);
    audio.setVolume(0.5);
    audio.setRefDistance(10);
    // audio.setBuffer(buffer)
    // audio.play()
    // })
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _three = __webpack_require__(1);

exports.default = {
  name: 'Renderer',

  provide: function provide() {
    return {
      parentObj: null, // avoid "injection not found" warning
      global: this.global
    };
  },


  props: {
    size: {
      type: Object, // { w, h }
      required: true
    },
    obj: { type: Object }
  },

  data: function data() {
    var curObj = this.obj;

    if (!curObj) {
      curObj = new _three.WebGLRenderer({ antialias: true });
      curObj.setClearColor(0x000000);
    }
    curObj.name = curObj.name || curObj.type;
    curObj.setSize(this.size.w, this.size.h);

    // fixme: better solution for global vars
    var global = {};
    global.rendererSize = this.size;
    global.rendererDom = curObj.domElement;

    return { curObj: curObj, global: global };
  },
  mounted: function mounted() {
    this.$refs.container.appendChild(this.curObj.domElement);
    this.animate();
  },


  methods: {
    animate: function animate() {
      requestAnimationFrame(this.animate);
      this.curObj.render(this.global.scene, this.global.camera);
    }
  }
}; //
//
//
//
//
//
//

/* global requestAnimationFrame */

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Scene',
  mixins: [_Object3D2.default],

  inject: [].concat((0, _toConsumableArray3.default)(_Object3D2.default.inject), ['global']),

  props: {
    obj: { type: Object }
  },

  data: function data() {
    var curObj = this.obj;
    if (!curObj) {
      curObj = new _three.Scene();
    }
    curObj.name = curObj.name || curObj.type;
    return { curObj: curObj };
  },
  mounted: function mounted() {
    var scene = this.curObj;
    this.global.scene = scene;

    // for threejs-inspector to work
    // https://github.com/jeromeetienne/threejs-inspector
    if (false) {
      window.THREE = THREE;
      window.scene = scene;
    }
  }
};
/* eslint-disable no-duplicate-imports */

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dat = __webpack_require__(122);

exports.default = {
  name: 'dat-gui',
  props: {
    model: { type: Object, required: true },
    setup: { type: Function, required: true }
  },

  data: function data() {
    var gui = new _dat.GUI({ autoPlace: false });
    this.setup(gui, this.model);
    return { gui: gui };
  },
  mounted: function mounted() {
    this.$refs.panel.appendChild(this.gui.domElement);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.panel.removeChild(this.gui.domElement);
  }
}; //
//
//
//

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Base = __webpack_require__(12);

var _Base2 = _interopRequireDefault(_Base);

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Geometry',
  mixins: [_Base2.default],
  props: {
    args: { type: Array, default: function _default() {
        return [];
      } },
    type: { type: String, default: '' }
  },

  data: function data() {
    var mod = this.type + 'Geometry';
    var geometry = new (Function.prototype.bind.apply(THREE[mod], [null].concat((0, _toConsumableArray3.default)(this.args))))();
    return { geometry: geometry };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.dispatchEvent('vm-geometry', _this.geometry);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatchEvent('vm-geometry', null);
  }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Base = __webpack_require__(12);

var _Base2 = _interopRequireDefault(_Base);

var _three = __webpack_require__(1);

var THREE = _interopRequireWildcard(_three);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Material',
  mixins: [_Base2.default],
  props: {
    options: { type: Object, default: function _default() {} },
    type: { type: String, default: '' }
  },

  data: function data() {
    var mod = this.type + 'Material';
    var material = new THREE[mod](this.options);
    return { material: material };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.dispatchEvent('vm-material', _this.material);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatchEvent('vm-material', null);
  }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Mesh',
  mixins: [_Object3D2.default],
  props: {
    type: { type: String, default: 'Mesh' }
  },

  methods: {
    handleGeometry: function handleGeometry(e) {
      e.stopPropagation();
      this.curObj.geometry = e.detail;
    },
    handleMaterial: function handleMaterial(e) {
      e.stopPropagation();
      this.curObj.material = e.detail;
    }
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(14);

var _assign2 = _interopRequireDefault(_assign);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'oimo-body',
  mixins: [_Object3D2.default],
  inject: ['world'],
  props: { options: Object },

  data: function data() {
    return { body: null };
  },
  mounted: function mounted() {
    var _this = this;

    var opts = {};
    (0, _assign2.default)(opts, this.options);

    var body = this.world.add(opts);
    body.connectMesh(this.curObj);
    this.body = body;

    // If you want to wait until the entire view has been rendered
    // https://vuejs.org/v2/api/#mounted
    this.$nextTick(function () {
      _this.dispatchEvent('vm-oimo-body', body);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.body.dispose();
    this.dispatchEvent('vm-oimo-body', null);
  }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(14);

var _assign2 = _interopRequireDefault(_assign);

var _oimo = __webpack_require__(126);

var Oimo = _interopRequireWildcard(_oimo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'oimo-world',
  provide: function provide() {
    return { world: this.world };
  },

  props: { options: Object },

  data: function data() {
    var opts = {
      gravity: [0, 0, 0] // no gravity as default
    };
    (0, _assign2.default)(opts, this.options);

    var world = new Oimo.World(opts);
    return { world: world };
  },
  destroyed: function destroyed() {
    this.world.clear();
  },


  methods: {
    animate: function animate() {
      this.world.step();
    }
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'space-object',
  inject: ['spaceVms'],

  data: function data() {
    return { body: null };
  },
  mounted: function mounted() {
    this.spaceVms.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    var index = this.spaceVms.indexOf(this);
    if (index > -1) this.spaceVms.splice(index, 1);
  },


  methods: {
    handleBody: function handleBody(e) {
      e.stopPropagation();
      this.body = e.detail;
    }
  }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(84);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _Animation = __webpack_require__(27);

var _Animation2 = _interopRequireDefault(_Animation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'space-system',
  components: { Animation: _Animation2.default },
  props: {
    mScale: { type: Number, default: 1 }
  },

  provide: function provide() {
    return { spaceVms: this.spaceVms };
  },
  data: function data() {
    return { spaceVms: [] };
  },


  methods: {
    uniGravity: function uniGravity() {
      // apply universal gracity
      // https://en.wikipedia.org/wiki/Gravitational_constant
      var G = 6.67408 * Math.pow(10, -11);
      var arr = this.spaceVms;
      var len = arr.length;

      for (var i = 0; i < len; i++) {
        for (var j = i + 1; j < len - i; j++) {
          var _map = [i, j].map(function (k) {
            return arr[k];
          }),
              _map2 = (0, _slicedToArray3.default)(_map, 2),
              vm1 = _map2[0],
              vm2 = _map2[1];

          var _map3 = [vm1, vm2].map(function (vm) {
            return vm.body;
          }),
              _map4 = (0, _slicedToArray3.default)(_map3, 2),
              b1 = _map4[0],
              b2 = _map4[1];

          if (!b1 || !b2) continue;

          var _map5 = [b1, b2].map(function (b) {
            return b.mass;
          }),
              _map6 = (0, _slicedToArray3.default)(_map5, 2),
              m1 = _map6[0],
              m2 = _map6[1];

          var _map7 = [b1, b2].map(function (b) {
            return b.getPosition();
          }),
              _map8 = (0, _slicedToArray3.default)(_map7, 2),
              p1 = _map8[0],
              p2 = _map8[1];

          var fv1 = p2.clone().sub(p1);
          var fvn1 = fv1.normalize();

          var r = fv1.length();
          var F = G * m1 * m2 / Math.pow(r, 2);
          F = F * Math.pow(this.mScale, 2); // scale

          var F1 = fvn1.clone().multiplyScalar(F);
          var F2 = F1.clone().negate();
          b1.applyImpulse(p1, F1);
          b2.applyImpulse(p2, F2);
        }
      }
    }
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _MovementObject = __webpack_require__(46);

var _MovementObject2 = _interopRequireDefault(_MovementObject);

var _util = __webpack_require__(29);

var _vue = __webpack_require__(28);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MassObject',
  mixins: [_MovementObject2.default],

  // Vue provide/inject not inherited??
  // inject: [
  //   ...MovementObject.inject
  // ],

  props: {
    f: Object,
    m: { type: Number, default: 1 }
  },

  data: function data() {
    return {
      innerF: []
    };
  },


  computed: {
    a: function a() {
      return _util.$vec.multiplyScalar(this.sumF, 1 / this.m);
    },
    sumF: function sumF() {
      var f = this.f,
          innerF = this.innerF;

      f = Array.isArray(f) ? f : [f];
      var allF = [].concat((0, _toConsumableArray3.default)(f), (0, _toConsumableArray3.default)(innerF));
      var sumF = null;
      allF.forEach(function (f) {
        sumF = _util.$vec.add(sumF, f);
      });
      return sumF;
    }
  },

  // hack: remove prop from super class
  // https://stackoverflow.com/questions/45680047/vuejs-extend-component-remove-parents-property
  beforeCreate: function beforeCreate() {
    _vue2.default.delete(this.$options.props, 'a');
  }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(30);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(5);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MovementObject',
  mixins: [_Object3D2.default],
  components: { Object3D: _Object3D2.default },

  inject: [].concat((0, _toConsumableArray3.default)(_Object3D2.default.inject), ['movemVms']),

  props: {
    a: Object,
    v0: Object,
    ra: Object,
    rv0: Object
  },

  data: function data() {
    return {
      rot: { x: 0, y: 0, z: 0 },
      pos: { x: 0, y: 0, z: 0 },
      v: (0, _extends3.default)({}, this.v0),
      rv: (0, _extends3.default)({}, this.rv0)
    };
  },
  created: function created() {
    this.movemVms.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    var index = this.movemVms.indexOf(this);
    if (index > -1) this.movemVms.splice(index, 1);
  }
}; //
//
//
//
//
//

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Animation = __webpack_require__(27);

var _Animation2 = _interopRequireDefault(_Animation);

var _Object3D = __webpack_require__(2);

var _Object3D2 = _interopRequireDefault(_Object3D);

var _util = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MovementSystem',
  mixins: [_Object3D2.default],
  components: { Animation: _Animation2.default },

  provide: function provide() {
    return {
      movemVms: this.vms
    };
  },
  data: function data() {
    return { vms: [] };
  },


  methods: {
    animate: function animate(tt, dt) {
      this.vms.forEach(function (vm) {
        // position
        var dv = _util.$vec.multiplyScalar(vm.a, dt);
        vm.v = _util.$vec.add(vm.v, dv);
        var dx = _util.$vec.multiplyScalar(vm.v, dt);
        vm.pos = _util.$vec.add(vm.pos, dx);
        // rotation
        var drv = _util.$vec.multiplyScalar(vm.ra, dt);
        vm.rv = _util.$vec.add(vm.rv, drv);
        var drx = _util.$vec.multiplyScalar(vm.rv, dt);
        vm.rot = _util.$vec.add(vm.rot, drx);
      });
    }
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/water.bcfb939.jpg";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAJcEhZcwAADqcAAA6nAVWbS4sAAAAHdElNRQfbDAENJAg+ijbvAAACqElEQVRYw81XXW/TQBAcO/7Kh5tAKZUqgspDHioVhNT/yv/gvyBUCQmK2qIWVFpUmji2k+PhZgp7Es/2vUTO6c67s7Oz4+jd0cIBQBpFAIBquwUARPDP02QAABjz93rdAABiv41Zkpjnr6s1AKCIYwDA09Tva/1sWgBA7fx7YnS8kh1mIAQOGXHE54d2YyIuBj5m5xwA4EfdmP2SSOm+z6vKIzjw/094vozTniBQMjLV8LzyNRwwg72MkTofa7P1mVdEYD9PTc3FIa2TvPQv4v13recAr+kBAvcbX+MVf5+kPqOckFytax8xD+QBMhdVbbjxLGD9TdOY+1+NhoZb3SMgtm5YQ7FabJ4xI9XsjKw+X3uu7Akx3vONiIkL8yIHAIyI0OnvpdnvHgFFXDMi6YIUUDW+bRujfNPI77dCpqoMIuqus0AHtKSQ3SNwPBkZ5bsnO9csupRrMshNN4g7ymwx9uy+IYeWRPRNOTEvvGVXSE+6R0A10jocFgYRB2e6QGzWs5QzpW7skgPSAyGipfNZ1BclnAXK9YF9qto/zzJq/9Z0hTKWYmp2SPkeqHzqipb3f6+tsnaPwB0dSkIlVP+rlh8flob1u5mdfjq/o3Pc17okR4TovBgbP9E5AtH7t8fuXz8QznNNR00z7f+vK8QBISRuSGl/UWdmvVHC0AGFXfFluTK68NflOuOCdV7OR8+hzshHiFPdIxC6XEWsCBd0MOr7T0REfT7Pc/PdUG22xmOeTEvrkKiMl/QT3SOgvheLXxSFyVjeLVQ2zfsL+okDZKYr1AXSgdAHvJ6Me4JA6FTUxw05oanWbJxht5zTS05PIXVFrVdmul+IXpMDj1zpHIFTav0w9pEe5Jmp+ePXLmu7zz5OIltjKZ08ozgQ6ozuj7OeTMM/I8EsFwuKLjQAAAAASUVORK5CYII="

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lensflare0_alpha.614e5f0.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(167),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(160),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(163),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(124)
  __webpack_require__(125)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(162),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-384e9da4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(166),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(158),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(155),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mesh', {
    attrs: {
      "obj": _vm.ocean
    }
  }), _vm._v(" "), _c('animation', {
    attrs: {
      "fn": _vm.animate,
      "speed": 5
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('animation', {
    attrs: {
      "fn": _vm.animate
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('animation', {
    attrs: {
      "fn": _vm.uniGravity
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "vm-oimo-body": _vm.handleBody
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object3d', {
    attrs: {
      "position": _vm.pos,
      "rotation": _vm.rot
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), (_vm.world) ? _c('animation', {
    attrs: {
      "fn": _vm.animate
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object3d', {
    attrs: {
      "obj": _vm.listener,
      "position": _vm.position
    }
  })
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object3d', {
    attrs: {
      "position": _vm.pos
    }
  }, [(_vm.body) ? _c('div', [_c('mesh', {
    attrs: {
      "obj": _vm.body
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.detonation1,
      "position": {
        x: 5,
        z: 0.8
      }
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.detonation2,
      "position": {
        x: -5,
        z: 0.8
      }
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.shoot1,
      "position": {
        x: 5,
        z: 2.6
      }
    }
  }), _vm._v(" "), _c('mesh', {
    attrs: {
      "obj": _vm.shoot2,
      "position": {
        x: -5,
        z: 2.6
      }
    }
  }), _vm._v(" "), _c('animation', {
    attrs: {
      "fn": _vm.animate
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('renderer', {
    attrs: {
      "size": _vm.size
    }
  }, [_c('dat-gui', {
    attrs: {
      "setup": _vm.uiSetup,
      "model": _vm.ui
    }
  }), _vm._v(" "), _c('scene', [_c('orbit-controls', {
    attrs: {
      "position": _vm.ui.camera,
      "rotation": {
        x: 2,
        y: 0,
        z: 3
      }
    }
  }, [_c('camera'), _vm._v(" "), _c('audio-listener')], 1), _vm._v(" "), _c('light', {
    attrs: {
      "hex": 0xefefff,
      "intensity": 2,
      "position": {
        x: 50,
        y: 50,
        z: 50
      }
    }
  }), _vm._v(" "), _c('light', {
    attrs: {
      "hex": 0xefefff,
      "intensity": 2,
      "position": {
        x: -50,
        y: -50,
        z: -50
      }
    }
  }), _vm._v(" "), _c('ocean', {
    attrs: {
      "position": _vm.ui.ocean
    }
  }), _vm._v(" "), _c('sf03', {
    attrs: {
      "position": {
        y: 10
      },
      "scale": _vm.ui.sf03.scale
    }
  }), _vm._v(" "), _c('positional-audio', {
    attrs: {
      "position": {
        y: 10
      },
      "url": "static/Project_Utopia.ogg"
    }
  }), _vm._v(" "), _c('movement-system', {
    key: _vm.ui.movemSysKey
  }, [_c('mass-object', {
    attrs: {
      "rv0": {
        x: 2,
        y: 2
      },
      "v0": {
        x: 10
      },
      "f": {
        x: -3,
        y: -2
      },
      "m": 1
    }
  }, [_c('cube', {
    attrs: {
      "texture": "cobblestone",
      "size": 1
    }
  })], 1), _vm._v(" "), _c('mass-object', {
    attrs: {
      "rv0": {
        x: 2,
        z: 2
      },
      "v0": {
        z: 20
      },
      "f": {
        y: -1,
        z: -8
      },
      "m": 1.2
    }
  }, [_c('cube', {
    attrs: {
      "texture": "diamond",
      "size": 1.2
    }
  })], 1), _vm._v(" "), _c('movement-object', {
    attrs: {
      "rv0": {
        x: 2,
        z: 2
      },
      "v0": {
        x: 15,
        z: -20
      },
      "a": {
        x: -6,
        y: .5,
        z: 6
      }
    }
  }, [_c('cube', {
    attrs: {
      "texture": "redwool",
      "size": 1.1
    }
  })], 1)], 1), _vm._v(" "), _c('oimo-world', {
    attrs: {
      "options": {
        gravity: [0, 1, 0]
      }
    }
  }, [_c('space-system', {
    attrs: {
      "m-scale": Math.pow( 10, 4 )
    }
  }, _vm._l((_vm.textures), function(t) {
    return _c('space-object', {
      key: t
    }, [_c('oimo-body', {
      attrs: {
        "options": {
          move: true,
          density: 1
        }
      }
    }, [_c('cube', {
      attrs: {
        "texture": t,
        "size": 1
      }
    })], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "panel",
    staticClass: "panel"
  })
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audio) ? _c('object3d', {
    attrs: {
      "obj": _vm.audio
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    ref: "container"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object3d', {
    attrs: {
      "rotation": {
        y: Math.PI
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "vm-geometry": _vm.handleGeometry,
      "vm-material": _vm.handleMaterial
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mesh', {
    attrs: {
      "name": "Cube"
    }
  }, [_c('geometry', {
    attrs: {
      "type": "Box",
      "args": [_vm.size, _vm.size, _vm.size]
    }
  }), _vm._v(" "), _c('material', {
    attrs: {
      "type": "MeshBasic",
      "options": _vm.material
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./components/Animation.vue": 27,
	"./components/AudioListener.vue": 135,
	"./components/Base.vue": 12,
	"./components/Camera.vue": 136,
	"./components/Light.vue": 137,
	"./components/Object3D.vue": 2,
	"./components/OrbitControls.vue": 138,
	"./components/PositionalAudio.vue": 139,
	"./components/Renderer.vue": 140,
	"./components/Scene.vue": 141,
	"./dat/DatGui.vue": 142,
	"./mesh/Geometry.vue": 143,
	"./mesh/Material.vue": 144,
	"./mesh/Mesh.vue": 145,
	"./oimo/OimoBody.vue": 146,
	"./oimo/OimoWorld.vue": 147,
	"./oimo/SpaceObject.vue": 148,
	"./oimo/SpaceSystem.vue": 149,
	"./physics/MassObject.vue": 150,
	"./physics/MovementObject.vue": 46,
	"./physics/MovementSystem.vue": 151
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./MTLLoader.js": 51,
	"./OBJLoader.js": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cobblestone.png": 128,
	"./diamond.png": 129,
	"./redwool.png": 130
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;

/***/ })
],[49]);


// WEBPACK FOOTER //
// static/js/app.bc15f934402af5d79ed8.js